// extracted by mini-css-extract-plugin
export var actionButton = "_en-t";
export var buttonContainer = "_en-0";
export var buttonContainer2 = "_en-1";
export var buttonSection = "_en-2";
export var details = "_en-3";
export var dropdownItem = "_en-5";
export var dropdownItemsContainer = "_en-4";
export var fileInput = "_en-r";
export var headerButton = "_en-6";
export var icon = "_en-7";
export var input = "_en-8";
export var macroListItem = "_en-9";
export var mainContent = "_en-a";
export var microText = "_en-b";
export var modal = "_en-w";
export var optionsButton = "_en-c";
export var paperclip = "_en-s";
export var pillContent = "_en-d";
export var preview = "_en-e";
export var preview2 = "_en-f";
export var quillEditor = "_en-q";
export var selectedMacro = "_en-g";
export var sidebar = "_en-h";
export var sidebarHeader = "_en-j";
export var sidebarList = "_en-i";
export var sidebarListItem = "_en-k";
export var sidebarSearch = "_en-l";
export var snoozeDurationWrapper = "_en-v";
export var statusPillContainer = "_en-m";
export var tagsContainer = "_en-n";
export var unselectedMacro = "_en-o";
export var variable = "_en-u";
export var wrapper = "_en-p";